(function initPurchaseRouting(root, factory) {
  const api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root) root.LmcPurchaseRouting = api;
}(typeof window !== 'undefined' ? window : globalThis, function purchaseRoutingFactory() {
  function positiveVariantId(value) {
    const numeric = Number(value);
    return Number.isSafeInteger(numeric) && numeric > 0 ? numeric : null;
  }

  function buildPurchaseSelection({
    guideVariantId,
    vipVariantId,
    vipSelected,
    policyAccepted,
  }) {
    if (!policyAccepted) throw new Error('Please accept the policies to continue.');
    const guideId = positiveVariantId(guideVariantId);
    if (!guideId) throw new Error('Guide checkout is unavailable.');
    const vipId = positiveVariantId(vipVariantId);
    if (vipSelected && !vipId) throw new Error('VIP checkout is unavailable for this guide.');
    return {
      variantId: vipSelected ? vipId : guideId,
      quantity: 1,
      checkoutPath: '/checkout',
      purchaseMode: vipSelected ? 'vip' : 'one-time',
    };
  }

  function getPurchaseButtonLabel(vipSelected, priceLabel = '$4.99') {
    return vipSelected ? `Buy guide with VIP — ${priceLabel}` : `Buy guide once — ${priceLabel}`;
  }

  function buildPhoenixCheckoutUrl({
    checkoutBaseUrl = 'https://secureorder.livingmadeclear.com',
    shop = 'nguqz5-ue.myshopify.com',
    cartToken,
  }) {
    const store = String(shop || '').split('.')[0];
    const token = String(cartToken || '').replace('%3Fkey%3D', '?key=');
    if (!store || !token) throw new Error('Secure checkout is unavailable. Please try again.');
    const base = String(checkoutBaseUrl).replace(/\/+$/, '');
    return `${base}/?store=${encodeURIComponent(store)}&cart=${encodeURIComponent(token)}`;
  }

  function bindGuidePurchase({
    container,
    fetchImpl,
    navigate,
    shop = 'nguqz5-ue.myshopify.com',
    checkoutBaseUrl = 'https://secureorder.livingmadeclear.com',
  }) {
    if (!container) return null;
    const vip = container.querySelector('[name="vip_opt_in"]');
    const policy = container.querySelector('[name="policy_acceptance"]');
    const button = container.querySelector('[data-guide-cart-button="true"]');
    const status = container.querySelector('[data-purchase-status]');
    if (!vip || !policy || !button) return null;

    const update = () => {
      button.textContent = getPurchaseButtonLabel(vip.checked, container.dataset.guidePriceLabel || '$4.99');
      button.disabled = !policy.checked;
      button.setAttribute('aria-disabled', String(button.disabled));
      if (status) status.textContent = '';
    };

    vip.addEventListener('change', update);
    policy.addEventListener('change', update);
    button.addEventListener('click', async (event) => {
      event.preventDefault();
      try {
        const selection = buildPurchaseSelection({
          guideVariantId: container.dataset.guideVariantId,
          vipVariantId: container.dataset.vipVariantId,
          vipSelected: vip.checked,
          policyAccepted: policy.checked,
        });
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        if (status) status.textContent = 'Opening secure checkout…';

        const clearResponse = await fetchImpl('/cart/clear.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
        });
        if (!clearResponse.ok) throw new Error('Unable to prepare checkout. Please try again.');

        const addResponse = await fetchImpl('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{
              id: selection.variantId,
              quantity: selection.quantity,
              properties: { _purchase_mode: selection.purchaseMode },
            }],
          }),
        });
        if (!addResponse.ok) throw new Error('Unable to add this guide. Please try again.');

        const cartResponse = await fetchImpl('/cart.js', {
          method: 'GET',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        });
        if (!cartResponse.ok) throw new Error('Unable to open secure checkout. Please try again.');
        const cart = await cartResponse.json();
        navigate(buildPhoenixCheckoutUrl({ checkoutBaseUrl, shop, cartToken: cart.token }));
      } catch (error) {
        if (status) status.textContent = error.message;
        update();
      }
    });
    update();
    return { update };
  }

  function initGuidePurchases(documentRef, windowRef) {
    if (!documentRef || !windowRef || typeof windowRef.fetch !== 'function') return;
    documentRef.querySelectorAll('[data-guide-purchase]').forEach((container) => {
      bindGuidePurchase({
        container,
        fetchImpl: windowRef.fetch.bind(windowRef),
        navigate: (path) => windowRef.location.assign(path),
        shop: windowRef.Shopify?.shop,
      });
    });
  }

  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initGuidePurchases(document, window));
    } else {
      initGuidePurchases(document, window);
    }
  }

  return {
    bindGuidePurchase,
    buildPhoenixCheckoutUrl,
    buildPurchaseSelection,
    getPurchaseButtonLabel,
    initGuidePurchases,
  };
}));
